
<select class="custom-select" (change)="selectElement($event)">
    <option selected i18n>Open this select menu</option>
    <option value="1" i18n>Complete</option>
    <option value="2" i18n>InProgess</option>
    <option value="3" i18n>Incomplete</option>
    <option value="4" i18n>Pending</option>
</select>


<!-- logOut -->
<ng-template #templateDelete>

    <div class="modal-header" style="background-color: #FFD700;">
  
      <h4 class="modal-title pull-left d-block d-sm-none" style="font-size: 10px !important;" i18n>Transaction</h4>
      <h4 class="modal-title pull-left d-none d-sm-block" i18n>Transaction</h4>
      <button type="button" class="close pull-rigth" aria-label="Close" (click)="modalRef.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
  
    </div>
  
    <div class="modal-body">
       <p i18n>Set <strong>{{itemToModify}}</strong> to <strong>{{status}}</strong> ?</p>
    </div>
  
    <div class="modal-footer">
  
        <a class="boxed-btn4-xs pull-left h-15" (click)="modifyTransaction()" i18n>Yes</a>
        <a class="boxed-btn4-red-xs pull-rigth h-15" (click)="modalRef.hide()" i18n>No</a>
    </div>
  
  </ng-template>
  <!-- / delete  -->